import React from 'react';
import { motion } from 'framer-motion';
import { Github } from 'lucide-react';
import { projects, projectMetrics } from '../data/personalData';

export const FeaturedProjects: React.FC = () => {
  return (
    <section id="projects" className="py-24 px-6 bg-surface/30">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-10"
        >
          <p className="font-mono text-sm text-accent mb-2">## EXPLAIN ANALYZE</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-text">projects</h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6">
          {projects.map((project, i) => {
            const metrics = projectMetrics[project.id] ?? [];
            return (
              <motion.article
                key={project.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group rounded-lg border border-border bg-surface overflow-hidden hover:border-accent/50 transition-colors flex flex-col"
              >
                <div className="flex items-center gap-1.5 px-4 py-2.5 bg-raised border-b border-border">
                  <span className="w-2 h-2 rounded-full bg-danger/60" />
                  <span className="w-2 h-2 rounded-full bg-accent/60" />
                  <span className="w-2 h-2 rounded-full bg-accent2/60" />
                  <span className="ml-3 text-xs font-mono text-muted truncate">
                    {project.title.toLowerCase().replace(/\s+/g, '_')}.query
                  </span>
                </div>

                <div className="p-5 flex flex-col flex-1">
                  <h3 className="text-lg font-bold text-text mb-2">{project.title}</h3>
                  <p className="text-sm text-muted leading-relaxed mb-4 flex-1">
                    {project.description}
                  </p>

                  {metrics.length > 0 && (
                    <div className="grid grid-cols-2 gap-2 mb-4 font-mono text-xs">
                      {metrics.map((m) => (
                        <div
                          key={m.label}
                          className="rounded border border-border px-2.5 py-1.5 bg-background/40"
                        >
                          <div className="text-accent2">{m.value}</div>
                          <div className="text-muted">{m.label}</div>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="flex flex-wrap gap-1.5 mb-4">
                    {project.technologies.map((tech) => (
                      <span
                        key={tech}
                        className="px-2 py-0.5 text-[11px] font-mono rounded border border-border text-muted"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>

                  {project.repoUrl && (
                    <a
                      href={project.repoUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-1.5 text-sm font-mono text-accent hover:underline"
                    >
                      <Github size={14} />
                      view_repository()
                    </a>
                  )}
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
